import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {UIMessage} from '../messages/ui-message.model';
import {TranslateService} from '@ngx-translate/core';
import {tap} from 'rxjs/operators';
import {TrackJsService} from '../../services/trackjs.service';

@Injectable({
  providedIn: "root"
})
export class MessagesService {

  private messagesSubject = new BehaviorSubject<UIMessage>(null);

  message$: Observable<UIMessage> = this.messagesSubject.asObservable();

  trackJsService = inject(TrackJsService);

  constructor(private translate: TranslateService) {

  }

  clear() {
    this.messagesSubject.next(null);
  }

  error(text:string, reason?:string) {

    this.messagesSubject.next({type:'error', text});

    this.trackJsService.logError(text, reason);
  }

  warn(text:string) {
    this.messagesSubject.next({type:'warn', text});
  }

  info(text:string) {
    this.messagesSubject.next({type:'info', text});
  }

  success(text:string) {
    this.messagesSubject.next({type:'success', text});
  }

  i18nError(i18nCode:string, params:Object = {}, reason?:string) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.error(message, reason))
      )
      .subscribe();
  }

  i18nWarn(i18nCode:string, params:Object = {}) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.warn(message))
      )
      .subscribe();
  }

  i18nInfo(i18nCode:string, params:Object = {}) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.info(message))
      )
      .subscribe();
  }

  i18nSuccess(i18nCode:string, params:Object = {}) {
    this.translate.get(i18nCode, params)
      .pipe(
        tap(message => this.success(message))
      )
      .subscribe();
  }

}



